import axios from "axios";
import { axiosInstance } from "./axios";

const backendUrl = `/api/admin`;

interface EmailLoginRequest {
  email: string;
  newPassword: string;
  confirmPassword: string;
}
export const resetPassword = async (reqBody: EmailLoginRequest) => {
  return await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/api/admin/user/reset`,
    reqBody
  );
};

export const userLogin = async (reqBody: any) => {
  return await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/api/admin/user/login`,
    reqBody
  );
};

export const getAllInitiatives = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/fl-initiative?page=${page}&limit=${limit}`
  );
};

export const getAllLiteracyMsg = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/fl-message?page=${page}&limit=${limit}`
  );
};

export const getAllForms = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/forms?page=${page}&limit=${limit}`
  );
};

export const getAllLiveEvents = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/live-video?page=${page}&limit=${limit}`
  );
};

export const getAllVideoCategory = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/video-category?page=${page}&limit=${limit}`
  );
};

export const getAllVideos = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/video-gallery/category?page=${page}&limit=${limit}`
  );
};

export const getAllAnnouncement = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/announcements?page=${page}&limit=${limit}`
  );
};

export const getAllAdmins = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/user/get-all-users?page=${page}&limit=${limit}`
  );
};
export const getVideoData = async (id: string) => {
  return await axiosInstance.get(
    `${backendUrl}/video-gallery/fetch-youtube-data/${id}`
  );
};

export const getInitiativesById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/fl-initiative/${id}`);
};

export const getVideoById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/video-gallery/${id}`);
};

export const getCategoryById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/video-category/${id}`);
};

export const getFormById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/forms/${id}`);
};

export const getLiveEventById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/live-video/${id}`);
};

export const addInitiatives = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/fl-initiative`, formData);
};

export const getAppConfig = async () => {
  return await axiosInstance.get(`${backendUrl}/app-config`);
};

export const addAppConfig = async (Body: any) => {
  return await axiosInstance.put(`${backendUrl}/app-config`, Body);
};

export const addVideo = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/video-gallery`, formData);
};

export const addForm = async (body: any) => {
  return await axiosInstance.post(`${backendUrl}/forms`, body);
};

export const getAllCronJobs = async (page: number, limit: number) => {
  return await axiosInstance.get(
    `${backendUrl}/cron-jobs?page=${page}&limit=${limit}`
  );
};

export const getAllStatistics = async () => {
  return await axiosInstance.get(`${backendUrl}/statistics`);
};

interface LiveEventResponse {
  success: string;
  data: any;
  message: string;
}
export const addLiveEvent = async (
  formData: any
): Promise<LiveEventResponse> => {
  return await axiosInstance.post(`${backendUrl}/live-video`, formData);
};

export const addVideoCategory = async (reqBody: any) => {
  const response = await axiosInstance.post(
    `${backendUrl}/video-category`,
    reqBody
  );
  return response.data;
};

export const addAdmin = async (reqBody: any) => {
  const response = await axiosInstance.post(
    `${backendUrl}/user/register`,
    reqBody
  );
  return response.data;
};

export const updateInitiatives = async (formData: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/fl-initiative/${id}`, formData);
};

export const updateVideos = async (formData: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/video-gallery/${id}`, formData);
};

export const updateLiveEvents = async (formData: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/live-video/${id}`, formData);
};

export const updateForms = async (body: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/forms/${id}`, body);
};

export const updateCategory = async (body: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/video-category/${id}`, body);
};

export const getAnnouncementById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/announcements/${id}`);
};

export const getFlMessageById = async (id: String) => {
  return await axiosInstance.get(`${backendUrl}/fl-message/${id}`);
};

export const getSpecialMessage = async () => {
  return await axiosInstance.get(`${backendUrl}/sp-fl-message`);
};

export const addAnnouncement = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/announcements`, formData);
};

export const addFlMessages = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/fl-message`, formData);
};

export const addSpecialMessage = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/sp-fl-message`, formData);
};

export const updateSpecialMessage = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/sp-fl-message`, formData);
};

export const logout = async (formData: any) => {
  return await axiosInstance.post(`${backendUrl}/user/logout`, formData);
};

export const updateAnnouncement = async (formData: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/announcements/${id}`, formData);
};

export const updateFlMessage = async (formData: any, id: string) => {
  return await axiosInstance.put(`${backendUrl}/fl-message/${id}`, formData);
};

export const updateAdmin = async (id: string, data: any) => {
  return await axiosInstance.put(`${backendUrl}/user/update-user/${id}`, data);
};

// for superAdmin
export const getUserById = async (id: string) => {
  return await axiosInstance.get(`${backendUrl}/user/get-user/${id}`);
};

export const getUser = async () => {
  return await axiosInstance.get(`${backendUrl}/user/profile`);
};

export const deleteAnnoucement = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/announcements/${id}`);
};

export const deleteflMessage = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/fl-message/${id}`);
};

export const deleteliveEvents = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/live-video/${id}`);
};

export const deleteForm = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/forms/${id}`);
};

export const deleteFlInit = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/fl-initiative/${id}`);
};

export const deleteVideo = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/video-gallery/${id}`);
};

export const deleteVideoCategory = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/video-category/${id}`);
};

export const deleteUser = async (id: string) => {
  return await axiosInstance.delete(`${backendUrl}/user/${id}`);
};
